import axios from "axios";
import defaults from "axios/lib/defaults";
import {openToast} from "@/helpers.js";
import Vue from "vue";

const ACTIVATE_AXIOS_CACHE = false;
const AUTHENTICATION_SESSION_FIELD = "authenticationSession"; // Authentication storage, put here because everyone needs it...

export const BACKEND_API_URL = process.env.VUE_APP_API_URL;

let _realAxiosInstance = axios.create({
    baseURL: BACKEND_API_URL,
    timeout: 120000, // Long HTTP request timeout
    transformRequest: [
        function (data, headers) {
            if (!headers["Authorization"]) {
                /* Set default Authorization token if available */
                let access_token = getLocalAuthenticationSession().access_token;
                if (access_token) headers["Authorization"] = `Bearer ${access_token}`;
            }
            //headers["Accept-Language"] = localStorage.getItem('selected_language') || "en";
            return defaults["transformRequest"][0](data, headers);
        },
    ],
});

export function networkErrorHandler(error) {
    /* Default error handling for connectivity or http-level errors */
    let message, title;
    if (error.response)
        if (error.response.status == 403) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            title = "Erreur de permissions";
            message =
                "Votre session a peut-être expiré, veuillez dans ce cas recharger la page pour vous reconnecter au service.";
        } else {
            title = "Erreur de données";
            message = `Code d'erreur ${error.response.status} lors d'un appel au service.`;
        }
    else if (error.request) {
        // The request was made but no response was received
        // "error.request" is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        title = "Erreur de connectivité";
        message = "Impossible de joindre le service, veuillez rafraichir la page.";
    } else {
        // Something happened in setting up the request that triggered an Error
        title = "Erreur";
        message = "Veuillez rafraichir la page.";
    }

    openToast(title, message, true);
    throw error; // Prevents then() from proceeding
}

export function deleteLocalAuthenticationSession() {
    Vue.localStorage.remove(AUTHENTICATION_SESSION_FIELD);
}

export function getApiEndpoint(url, config) {
    let cached = window.localStorage.getItem(url);
    if (cached && ACTIVATE_AXIOS_CACHE)
        return Promise.resolve(JSON.parse(cached));

    return _realAxiosInstance
        .get(url, config)
        .catch(networkErrorHandler)
        .then((res) => {
            if (ACTIVATE_AXIOS_CACHE)
                window.localStorage.setItem(url, JSON.stringify(res));
            return res;
        });
}

export function getLocalAuthenticationSession() {
    return Vue.localStorage.get(AUTHENTICATION_SESSION_FIELD, {}, Object);
}

export function patchApiEndpoint(url, data, config) {
    return _realAxiosInstance.patch(url, data, config).catch(networkErrorHandler);
}

export function postApiEndpoint(url, data, config) {
    return _realAxiosInstance.post(url, data, config).catch(networkErrorHandler);
}

export function postApiEndpointUnprotected(url, data, config) {
    return _realAxiosInstance.post(url, data, config); // E.g. for login call!
}

export function rawGetUrl(url) {  // FIXME remove (unused)
    return _realAxiosInstance({
        url: url,
        method: "POST",
        responseType: "blob", // important
    }).catch(networkErrorHandler);
}

export function rawPostUrl(url, data) {
    return _realAxiosInstance({
        url: url,
        data: data,
        method: "POST",
        responseType: "blob", // important
    }).catch(networkErrorHandler);
}

export function triggerDownloadOfBinaryData(data, filename, blobType) {
    // Here data must ALREADY be a proper Blob with its content-type
    //[LOG] console.log("triggerDownloadOfBinaryData called for:", data);
    const url = window.URL.createObjectURL(new Blob([data], blobType));
    //[LOG]console.log("createObjectURL result:", url);
    const link = document.createElement("a");
    link.href = url;
    link.style.display = "none";
    link.setAttribute("download", filename); // or any other extension
    document.body.appendChild(link);
    link.click();
}

export function setLocalAuthenticationSession(data) {
    // Store absolute expiration date
    const expiresInHours = data.expires_in / 3600;
    const expirationDate = new Date();

    expirationDate.setHours(expirationDate.getHours() + expiresInHours);
    data.expiration_date = expirationDate;
    Vue.localStorage.addProperty(AUTHENTICATION_SESSION_FIELD, Object); // Important to force JSON decoding
    Vue.localStorage.set(AUTHENTICATION_SESSION_FIELD, data);
}

export function updateLocalAuthenticationSession(data) {
    const updatedData = Object.assign(getLocalAuthenticationSession(), data);

    setLocalAuthenticationSession(updatedData);
}
